export const environment = {
  production: true,
  envName: 'prod',
  name: 'prod',
  evcApi: 'https://totalenergies.be/simulator-evc-b2c-api',
  smeEvcApi: 'https://totalenergies.be/simulator-evc-b2b-api',
  baseUrl: 'https://services.lampiris.be',
  websiteUrl: 'https://totalenergies.be',
  thankYouPageNl:
    // eslint-disable-next-line max-len
    '/nl/particulieren/producten-en-diensten/my-e-drive/aanbod-elektrische-mobiliteit/bedankt-voor-je-offerteaanvraag-laadpaal',
  thankYouPageFr:
    '/fr/particuliers/produits-et-services/my-e-drive/offre-mobilite-electrique/merci-demande-devis-borne-de-recharge',
  portalUrl: 'https://my.totalenergies.be',
  googleTagManager: 'GTM-WNSPC3',
  sentry: 'https://e0c1404e3b994377957fe442088ca718@o542700.ingest.sentry.io/6095222',
  simulatorB2BNl: '/nl/professioneel/producten-en-diensten/my-business/ons-energieaanbod/bereken-jouw-prijs',
  simulatorB2BFr: '/fr/professionnels/produits-et-services/my-business/notre-offre-energie/calculez-votre-prix',
  pathPrefixSegmentB2CNl: '/nl/evc-segment',
  pathPrefixSegmentB2CFr: '/fr/evc-segment',
  pathPrefixSimulatorB2CNl: '/nl/evc-simulator',
  pathPrefixSimulatorB2CFr: '/fr/evc-simulator',
  pathPrefixQuoteB2CNl: '/nl/evc-quote',
  pathPrefixQuoteB2CFr: '/fr/evc-quote',
  pathPrefixQuoteSmeNl: '/nl/evc-small-biz',
  pathPrefixQuoteSmeFr: '/fr/evc-small-biz',
  homePageB2CNl: '/particulieren',
  homePageB2BNl: '/professioneel',
  homePageB2CFr: '/particuliers',
  homePageB2BFr: '/professionnels',
  languageAssetsPath: 'https://translation-cdn.lampiris.be/be-services-client/',
  maxChargingCards: 15,
  maxChargingStations: 4,
  electricDrivingNl:
    '/nl/professioneel/producten-en-diensten/schakel-over-op-elektrisch-rijden-met-onze-lokale-groene-energie',
  electricDrivingFr:
    '/fr/professionnels/produits-et-services/passez-a-la-mobilite-electrique-avec-notre-energie-verte-et-locale',
};
